
import { Component, Vue } from 'vue-property-decorator'
import ActivateMessage from '@/components/templates/activate/ActivateMessage.vue'

/**
 * 認証トークンエラーページ
 */
@Component({
  components: {
    ActivateMessage,
  },
})
export default class TokenInvalid extends Vue {
  /**
   * 戻るボタン押下時処理
   */
  private async eventSubmit(): Promise<void> {
    // TODO: 認証情報を削除
    await this.$router.push('/activate/login')
  }
}
